import { connect } from 'react-redux';
import {
  getUsageEvents,
  getUsageExecuteTime,
  getMetainf,
  getProjectZoneId,
} from '../../reducers/analyticsApp';
import EventTableView from '../../components/table/EventTableView';

const mapStateToProps = (state) => ({
  zoneId: getProjectZoneId(state),
  result: getUsageEvents(state) || [],
  executeTime: getUsageExecuteTime(state),
  metainf: getMetainf(state),
});

export default connect(mapStateToProps)(EventTableView);
